module.exports = __webpack_public_path__ + "web/img/mp4.8d929590.png";